module.exports = __webpack_public_path__ + "static/media/UpToDate.dcf8e1a4.svg";